import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPlans from '../reducers/plans.reducer';

export const getPlaning = createFeatureSelector<fromPlans.State>('plans');

export const getPlansList = createSelector(getPlaning, (s) => s.plans);

export const getPlanCalendar = createSelector(getPlaning, (s) => s.calendar);
